import axios from 'axios'

/**
 * 网络请求封装，与小程序 utils/request.js 保持一致。
 *
 * 小程序基地址：
 *   API 主机：  https://api.mini.roadlinkglb.com/zjs/mini/
 *   JSON 配置：https://res.roadlinkglb.com/config/mini/
 *
 * 前端统一只发三类带「域名语义」的前缀，开发与生产都按域名归并：
 *   /api -> https://api.mini.roadlinkglb.com  （仅做域名路由；真实路径如 /zjs/mini/... 由前端请求 URL 携带，配置不写死）
 *   /res -> https://res.roadlinkglb.com/                （静态资源 + JSON 配置，去掉 /res 前缀）
 *   /crm -> https://crm.roadlinkglb.com/                （CRM 入口，去掉 /crm 前缀）
 * 这样每个后端域名只需配置一次转发（vue.config.js 一个 proxy、nginx 一个 location）。
 *
 * 约定：业务接口返回 { code: 0, ... } 表示成功。
 */
const API_BASE = '/api'
const JSON_BASE = '/res/config/mini'

// 对应小程序 getParamOption：POST + JSON + _timespan
export async function post (url, data = {}) {
  const payload = { ...data, _timespan: Date.now() }
  const res = await axios.post(`${API_BASE}/${url}`, payload, {
    headers: { 'Content-Type': 'application/json' },
    timeout: 60000
  })
  const body = res.data
  if (body && body.code === 0) return body
  const msg = (body && (body.msg || body.message)) || '请求失败'
  throw new Error(msg)
}

// 对应小程序 getJsonConfigParamOption：GET 静态 json 配置
export async function getJson (url) {
  const res = await axios.get(`${JSON_BASE}/${url}`, { timeout: 60000 })
  return res.data
}
